module.exports = __webpack_public_path__ + "static/media/zktecodevice.5a211fed.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/zktecodevice.PNG
// module id = 1530
// module chunks = 0